'use client';

import * as React from 'react';

/**
 * @ignore - internal component.
 */

export const NotificationsContext = /*#__PURE__*/React.createContext(null);